import zhCN from "./zh-CN/index";

export default zhCN;
